import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ContextStoreProvider from './store/ContextStore';
import { ReportIssueProvider } from './contenxt/ReportIssueContext';
import { initGTM } from './services/gtm';
import setupInterceptors from './utils/setupInterceptors';

// Initialize GTM before React renders
const gtmId = process.env.REACT_APP_GTM_ID;
if (gtmId) { initGTM(gtmId); }

// Register global axios interceptors once (trial expired, unauthorized, etc.)
setupInterceptors();

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  <ContextStoreProvider>
    <ReportIssueProvider>
      <App />
    </ReportIssueProvider>
  </ContextStoreProvider>
);
